import Entity from '../Entity';

export default class UserEpisodeReadingStartTime implements Entity {
  constructor(
    public id: number,
    public episodeId: number,
    public createdAt: Date,
    public updatedAT: Date,
  ) {}
}
